/** Shim for react-horizontal-timeline (expects react-icons@2 path). */
const { FaAngleRight } = require('react-icons/fa');

module.exports = FaAngleRight;
